export default "<button #fileButton class=\"btn btn-primary\" (click)=\"exportCsv()\">{{buttonText}}</button>"